export const isAdminSession = privileges => (
    privileges !== undefined &&
    privileges !== null &&
    typeof privileges === 'object'
);

export const isMainAdmin = privileges => privileges?.main === true;
